"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var report_model_parser_1 = require("./report-model.parser");
var ReportModelHelper = /** @class */ (function () {
    function ReportModelHelper() {
    }
    ReportModelHelper.collectRowIds = function (reportTableView) {
        return this.collectRowItemIds(reportTableView);
    };
    ReportModelHelper.collectColumnIds = function (reportTableView) {
        return this.collectColumnItemIds(reportTableView);
    };
    ReportModelHelper.getRowBranches = function (reportTableView) {
        var tree = [];
        var stack = [];
        var reportDto = report_model_parser_1.ReportModelParser.parse(reportTableView);
        this.createRowBranches(tree, reportDto.rowRootDto.children, stack);
        return tree;
    };
    ReportModelHelper.getRowIdsAsString = function (rowBranch) {
        var rowIds = '';
        for (var _i = 0, rowBranch_1 = rowBranch; _i < rowBranch_1.length; _i++) {
            var item = rowBranch_1[_i];
            if (rowIds !== '') {
                rowIds = rowIds.concat(',');
            }
            rowIds = rowIds.concat(item.categoryElementDto.categoryPathHolderId.toString());
        }
        return rowIds;
    };
    ReportModelHelper.getRowIds = function (row) {
        var rowIds = [];
        rowIds.push(row.element.categoryElementDto.categoryPathHolderId);
        while (row.parent !== null) {
            row = row.parent;
            rowIds.push(row.element.categoryElementDto.categoryPathHolderId);
        }
        return rowIds.reverse().join(',');
    };
    ReportModelHelper.createRowBranches = function (rowBranches, rowElements, branchElements) {
        if (rowElements == null || rowElements.length === 0) {
            var branch = [];
            rowBranches.push(branch);
            for (var _i = 0, branchElements_1 = branchElements; _i < branchElements_1.length; _i++) {
                var branchElement = branchElements_1[_i];
                branch.push(branchElement);
            }
        }
        else {
            for (var _a = 0, rowElements_1 = rowElements; _a < rowElements_1.length; _a++) {
                var rowCategoryElement = rowElements_1[_a];
                branchElements.push(rowCategoryElement);
                this.createRowBranches(rowBranches, rowCategoryElement.children, branchElements);
                branchElements.pop();
            }
        }
    };
    ReportModelHelper.collectRowItemIds = function (tableReportView) {
        var report = report_model_parser_1.ReportModelParser.parse(tableReportView);
        var ids = [];
        this.collectIds(report.rowRootDto.children, ids);
        return ids;
    };
    ReportModelHelper.collectColumnItemIds = function (tableReportView) {
        var report = report_model_parser_1.ReportModelParser.parse(tableReportView);
        var ids = [];
        this.collectIds(report.columnRootDto.children, ids);
        return ids;
    };
    ReportModelHelper.collectIds = function (items, ids) {
        for (var i = 0; i < items.length; i++) {
            var currentElement = items[i];
            if (currentElement instanceof idm_reporting_service_client_js_1.RowCategoryDto) {
                ids.push(currentElement.categoryElementDto.categoryPathHolderId);
            }
            else if (currentElement instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                ids.push(currentElement.categoryElementDto.categoryPathHolderId);
            }
            else if (currentElement instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                ids.push(currentElement.measurePathHolderId);
            }
            if (currentElement.children && currentElement.children.length > 0) {
                this.collectIds(currentElement.children, ids);
            }
        }
    };
    return ReportModelHelper;
}());
exports.ReportModelHelper = ReportModelHelper;
//# sourceMappingURL=report-model-helper.js.map